/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_HeInputs */

const en_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const es_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const de_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const zh_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const ar_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const fr_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const vi_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const sw_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const th_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const bs_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const ja_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const ko_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const pt_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const it_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const sv_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const nl_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const da_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const nb_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const fi_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const pl_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const ru_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const tr_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const hi_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const id_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const ms_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const cs_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const el_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const he_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const af_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

const hu_nav_language_he = /** @type {(inputs: Nav_Language_HeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית`)
};

/**
* | output |
* | --- |
* | "עברית" |
*
* @param {Nav_Language_HeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_he = /** @type {((inputs?: Nav_Language_HeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_HeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_he(inputs)
	if (locale === "de") return de_nav_language_he(inputs)
	if (locale === "zh") return zh_nav_language_he(inputs)
	if (locale === "ar") return ar_nav_language_he(inputs)
	if (locale === "fr") return fr_nav_language_he(inputs)
	if (locale === "vi") return vi_nav_language_he(inputs)
	if (locale === "sw") return sw_nav_language_he(inputs)
	if (locale === "th") return th_nav_language_he(inputs)
	if (locale === "bs") return bs_nav_language_he(inputs)
	if (locale === "ja") return ja_nav_language_he(inputs)
	if (locale === "ko") return ko_nav_language_he(inputs)
	if (locale === "pt") return pt_nav_language_he(inputs)
	if (locale === "it") return it_nav_language_he(inputs)
	if (locale === "sv") return sv_nav_language_he(inputs)
	if (locale === "nl") return nl_nav_language_he(inputs)
	if (locale === "da") return da_nav_language_he(inputs)
	if (locale === "nb") return nb_nav_language_he(inputs)
	if (locale === "fi") return fi_nav_language_he(inputs)
	if (locale === "pl") return pl_nav_language_he(inputs)
	if (locale === "ru") return ru_nav_language_he(inputs)
	if (locale === "tr") return tr_nav_language_he(inputs)
	if (locale === "hi") return hi_nav_language_he(inputs)
	if (locale === "id") return id_nav_language_he(inputs)
	if (locale === "ms") return ms_nav_language_he(inputs)
	if (locale === "cs") return cs_nav_language_he(inputs)
	if (locale === "el") return el_nav_language_he(inputs)
	if (locale === "he") return he_nav_language_he(inputs)
	if (locale === "af") return af_nav_language_he(inputs)
	if (locale === "hu") return hu_nav_language_he(inputs)
	return en_nav_language_he(inputs)
});